import * as fetch from 'isomorphic-fetch';
import { SystemEvent, SystemEventLevel } from 'bernie-logger';
var GDPR_OPT_IN_REQUEST_FAILED = new SystemEvent(SystemEventLevel.ERROR, 'GDPR_OPT_IN_REQUEST_FAILED');
var defaultUrl = '/opt-in-select/cookie/create/OIP?png=true&value=1';
var setOptInWithReload = function (logger) { return fetch(bannerUtils.defaultUrl, { method: 'GET' })
    .then(function (res) {
    if (!res.ok) {
        throw new Error("Request for GDPR opt in failed. Status " + res.status);
    }
    window.location.reload(false);
})
    .catch(function (err) {
    if (logger) {
        logger.logEvent(GDPR_OPT_IN_REQUEST_FAILED, err.message);
    }
}); };
export var bannerUtils = {
    defaultUrl: defaultUrl,
    setOptInWithReload: setOptInWithReload
};
//# sourceMappingURL=banner-utils.js.map